import { Link } from 'gatsby';
import styled from 'styled-components';

export const SSection = styled.section`
  border-radius: 5px;
  display flex;
  flex-wrap: wrap;
  align-content: center;
`;

export const SPopularTag = styled(Link)`
  background: ${props => props.theme.colors.accent};
  color: #ffffff;
  font-size: 13px;
  padding: 10px;
  border-radius: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  text-transform: capitalize;
  &:hover {
    color: #ffffff;
  }
`;

export const SSectionTitle = styled.h5`
  margin-bottom: 25px;
  width: 100%;
`;

export const SAllLink = styled(Link)`
  font-size: 14px;
`;
